import { Inserter } from "nystem-components";

const TravelsOutlet = ({ model }) => <Inserter match={model.match} source={model.source} className={model.className} />;

export default TravelsOutlet;
